import React, { useRef, useEffect } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { getters } from "../model";
import { Panel } from "EventLight/Common/FieldLayout";
import { Div } from "components/Base";
import MessageList from "./MessageList";

const decorate = connect(
  state => ({
    messages: getters.messages(state)
  }),
  {}
);

const Messages = ({ messages }) => {
  const bottomMessageRef = useRef(null);

  useEffect(() => {
    return bottomMessageRef?.current?.scrollIntoView({ behavior: "smooth" });
  }, [bottomMessageRef, messages]);

  return (
    <Div bg="neutral0" style={{ overflowY: "auto", padding: 25, height: 600 }}>
      <Panel>
        {!R.isEmpty(messages) &&
          messages.map(message => <MessageList {...message} />)}
      </Panel>
      <div ref={bottomMessageRef}></div>
    </Div>
  );
};

export default decorate(Messages);
